import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../Footer";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BtnLoader } from "../components/PageLoader";
import axios from "axios";

const Login = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const optionToast = {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
    transition: Bounce,
  };

  useEffect(() => {
    try {
      const stored = localStorage.getItem("userData");
      if (stored) {
        const user = JSON.parse(stored);
        if (user?.id) {
          const defaultPath = user.role === "dealer" ? "/dealer/dashboard" : "/profilesetting";
          navigator(location.state?.from || defaultPath, { replace: true });
        }
      }
    } catch (_) { }
  }, [navigator, location]);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [dealerEmail, setDealerEmail] = useState("");
  const [dealerPassword, setDealerPassword] = useState("");

  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const [isDealerPassShow, setisDealerPassShow] = useState(false);
  const [activeTab, setActiveTab] = useState("user");
  const [loginLoading, setLoginLoading] = useState(false);

  const togglePasswordVisibilityConfirm = () => {
    setShowPasswordConfirm(!showPasswordConfirm);
  };
  const togglePasswordDealer = () => {
    setisDealerPassShow(!isDealerPassShow);
  };
  const handleLogin = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      toast.error("Please enter a valid email address", optionToast);
      return;
    }
    fetchData();
  };
  const handleDealerLogin = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!dealerEmail || !emailRegex.test(dealerEmail)) {
      toast.error("Please enter a valid Dealer email address", optionToast);
      return;
    }
    loginDealer();
  };
  const saveDataTolocalStorage = (key, data) => {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem(key, serializedData);
    } catch (error) {
      console.error("Error saving data to localStorage:", error);
    }
  };

  const fetchData = async () => {
    setLoginLoading(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/auth/login",
        {
          email: email,
          password: password,
        }
      );
      if (response?.data?.success) {
        const newUserData = { ...(response?.data?.data?.user || {}) };
        if (response?.data?.data?.token) {
          newUserData.token = response?.data?.data?.token;
        }
        saveDataTolocalStorage("userData", newUserData);
        showAlert(
          response?.data?.message,
          response?.data?.data?.user?.id,
          response?.data?.success,
          1
        );
      } else {
        toast.error(response?.data?.message, optionToast);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setLoginLoading(false);
    }
  };
  const loginDealer = async () => {
    setLoginLoading(true);
    try {
      const response = await axios.post(
        window.CARLOCA_API + "/auth/dealer/login",
        {
          email: dealerEmail,
          password: dealerPassword,
        }
      );
      if (response?.data?.success) {
        const newUserData = { ...(response?.data?.data?.user || {}) };
        if (response?.data?.data?.token) {
          newUserData.token = response?.data?.data?.token;
        }
        saveDataTolocalStorage("userData", newUserData);
        showAlert(
          response?.data?.message,
          response?.data?.data?.user?.id,
          response?.data?.success,
          2
        );
      } else {
        toast.error(response?.data?.message, optionToast);
      }
    } catch (error) {
      console.log("An error occurred while fetching data.", error);
    } finally {
      setLoginLoading(false);
    }
  };
  const showAlert = (data, id, show, is) => {
    if (show) {
      toast.success(data, optionToast);
      setTimeout(() => {
        if (location.state?.from) {
          navigator(location.state.from);
        } else if (is === 1) {
          navigator("/profilesetting");
        } else if (is === 2) {
          navigator("/dealer/dashboard");
        } else {
          navigator("/login");
        }
      }, 1500);
    } else {
      toast.error(data, optionToast);
    }
  };

  return (
    <>
      <Navbar />
      <div className="cl-auth-page" style={{ paddingTop: 78 }}>
        <div className="cl-auth-card" style={{ maxWidth: 480 }}>
          <div className="text-center mb-3">
            <img src="/img/Logo_trusted_Cars.png" alt="Trusted Cars" style={{ height: 44, marginBottom: 10 }} />
          </div>
          <h5 className="cl-auth-title">Welcome Back</h5>
          <p className="cl-auth-subtitle">Sign in to your account to continue</p>

          {/* Tab toggle */}
          <div className="cl-tabs mb-3">
            <button className={`cl-tab${activeTab === "user" ? " active" : ""}`} onClick={() => setActiveTab("user")}>
              <i className="fa-solid fa-user me-1"></i>User
            </button>
            <button className={`cl-tab${activeTab === "dealer" ? " active" : ""}`} onClick={() => setActiveTab("dealer")}>
              <i className="fa-solid fa-store me-1"></i>Dealer
            </button>
          </div>

          {/* User Login */}
          {activeTab === "user" && (
            <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
              <div className="mb-3">
                <label className="cl-form-label">Email</label>
                <div className="position-relative">
                  <input type="email" placeholder="you@email.com"
                    className="cl-form-control" style={{ paddingLeft: 38 }}
                    value={email} onChange={(e) => setEmail(e.target.value)} />
                  <i className="fa-solid fa-envelope" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 14 }}></i>
                </div>
              </div>
              <div className="mb-3">
                <label className="cl-form-label">Password</label>
                <div className="position-relative">
                  <input type={showPasswordConfirm ? "text" : "password"} placeholder="â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢"
                    className="cl-form-control" style={{ paddingLeft: 38, paddingRight: 40 }}
                    value={password} onChange={(e) => setPassword(e.target.value)} />
                  <i className="fa-solid fa-lock" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 14 }}></i>
                  <div style={{ position: "absolute", top: "50%", right: 12, transform: "translateY(-50%)", cursor: "pointer" }}
                    onClick={togglePasswordVisibilityConfirm}>
                    <i className={`fa-solid ${showPasswordConfirm ? "fa-eye-slash" : "fa-eye"}`} style={{ color: "#b0bac5", fontSize: 14 }}></i>
                  </div>
                </div>
              </div>
              <div className="text-end mb-3">
                <Link to="/forgetpassword" style={{ fontSize: 13, color: "#00889c", fontWeight: 600, textDecoration: "none" }}>
                  Forgot password?
                </Link>
              </div>
              <button type="submit" className="cl-btn cl-btn-primary cl-btn-lg w-100" disabled={loginLoading}>
                {loginLoading ? <><BtnLoader />Signing in...</> : "Sign In"}
              </button>
              <div className="cl-auth-divider mt-3">or</div>
              <Link to="/register" className="cl-btn cl-btn-outline cl-btn-lg w-100">Create an Account</Link>
            </form>
          )}

          {/* Dealer Login */}
          {activeTab === "dealer" && (
            <form onSubmit={(e) => { e.preventDefault(); handleDealerLogin(); }}>
              <div className="mb-3">
                <label className="cl-form-label">Dealer Email</label>
                <div className="position-relative">
                  <input type="email" placeholder="dealer@email.com"
                    className="cl-form-control" style={{ paddingLeft: 38 }}
                    value={dealerEmail} onChange={(e) => setDealerEmail(e.target.value)} />
                  <i className="fa-solid fa-envelope" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 14 }}></i>
                </div>
              </div>
              <div className="mb-3">
                <label className="cl-form-label">Password</label>
                <div className="position-relative">
                  <input type={isDealerPassShow ? "text" : "password"} placeholder="â€¢â€¢â€¢â€¢â€¢â€¢â€¢â€¢"
                    className="cl-form-control" style={{ paddingLeft: 38, paddingRight: 40 }}
                    value={dealerPassword} onChange={(e) => setDealerPassword(e.target.value)} />
                  <i className="fa-solid fa-lock" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "#b0bac5", fontSize: 14 }}></i>
                  <div style={{ position: "absolute", top: "50%", right: 12, transform: "translateY(-50%)", cursor: "pointer" }}
                    onClick={togglePasswordDealer}>
                    <i className={`fa-solid ${isDealerPassShow ? "fa-eye-slash" : "fa-eye"}`} style={{ color: "#b0bac5", fontSize: 14 }}></i>
                  </div>
                </div>
              </div>
              <div className="text-end mb-3">
                <Link to="/forgetpassword" style={{ fontSize: 13, color: "#00889c", fontWeight: 600, textDecoration: "none" }}>
                  Forgot password?
                </Link>
              </div>
              <button type="submit" className="cl-btn cl-btn-primary cl-btn-lg w-100" disabled={loginLoading}>
                {loginLoading ? <><BtnLoader />Signing in...</> : "Dealer Sign In"}
              </button>
              <div className="cl-auth-divider mt-3">or</div>
              <Link to="/dealer-register" className="cl-btn cl-btn-outline cl-btn-lg w-100">Dealer Registration</Link>
            </form>
          )}
        </div>
      </div>
      <Footer />
      <ToastContainer />
    </>
  );
};

export default Login;
